<template>
  <div id="app" ref="wholeBody">
      <div class="tweet">
          <button id="tweetBtn">New Tweets</button>
      </div>
<!--    <Internet :data="notiData"></Internet>-->
<!--     <notification :data="notiData" />-->
    <!-- Take not that the offline tag is needed for the offline notification to work so don't remove it except you have a better one -->
<!--    <offline @detected-condition="handleConnectivityChange"></offline>-->
    <router-view />
  </div>
</template>

<script>
import ls from "./localstorage";
import Internet from "./components/Internet";
import {mapState} from 'vuex';
export default {
  name: "app",
  data() {
    return {
      notiData: {},
      username: "",
        to: '',
        from: '',
    };
  },
  watch: {
    $route(to, from) {
      this.to = to;
      this.from = from;
    },
  },
    computed: {
        ...mapState(['notifications']),
        getNotifications() {
            return this.notifications
        },
    },
  components: {Internet},
    methods: {
      handleScroll() {
          alert('scrolling')
      },
    async generateContents() {
      // store the user data in the system state
      if (ls.checkStorage("fansData")) {
        let fansData = ls.getStorage("fansData");
        let user_type = fansData[0].user_type;
        this.axios
          .get("/user/details")
          .then(response => {
            var userData = response.data.data;
              const data = {
                  email: userData.email,
                  firstname: userData.firstname,
                  lastname: userData.lastname,
                  username: userData.username,
                  club: userData.team_details,
                  avatar: userData.avatar,
              };
              this.getAllNotifications();
            if (this.$storeLocalData(data)) {
              window.eventBus.$emit("localDataStored", true);
            }
          })
          .catch(error => {
            // console.log(error);
            return error;
          });
      }
    },
    handleConnectivityChange(status) {
      // console.log(status);
      if (status === false) {
        this.notiData = {
          type: "error",
          message:
            "Connect to an active network to enjoy the full extent of Matchdaydeals",
          isError: true,
        };
      } else {
        this.notiData = {
          type: "success",
          message: "Great!, now you can enjoy the full extent of Matchdaydeals",
          isError: true,
        };
      }
    },
    checkUserActiveTime() {
      // we check if the user is not meant to be logged in for more than 24 hours
      if (ls.checkStorage("ticket")) {
        let ticketData = ls.getStorage("ticket");
        ticketData = ticketData[0].token_generation;
        let tsYesterday = ticketData - (24 * 3600);

        // console.log(ticketData)

      }
    },
    getUserContributions() {
      if (ls.checkStorage("fansData")) {
        let userData = localStorage.fansData;
        userData = JSON.parse(userData);
        let id = userData[0].id;
        this.axios.get("/user/contributions/" + id)
                .then(response => {
                  const payload = {
                    followers: response.data.data.followers,
                    followings: response.data.data.followings,
                    reviews: response.data.data.reviews,
                  };
                  this.$store.commit("setContributions",payload)
                })
                .catch(error => {
                  // console.log(error);
                  return error;
                })
      }
    },
    getAllUnreadNotification() {
        const noti = this.getNotifications
        this.axios.get('/notifications/unread/1000')
        .then((res) => {
            const data = res.data.data;
            const newNoti = {
                data: noti.data,
                total: data.count,
                first_page_url: noti.first_page_url,
                last_page_url: noti.last_page_url,
                next_page_url: noti.next_page_url,
            };
            this.$store.commit('setNotifications',newNoti)
            if (data.count > 0 ) {
                // const $title = $('title').html()
                // $('title').html(`(${data.count}) ${$title}`)
            }
        })
    },
    getAllNotifications() {
        this.axios.get(`/notifications/all/100`)
        .then((res) => {
            const data = res.data.data.notifications;
            const notifications = {
                first_page_url: data.first_page_url,
                last_page_url: data.last_page_url,
                next_page_url: data.next_page_url,
                total: 0,
                data: data.data,
            };
            this.$store.commit('setNotifications', notifications);
            this.getAllUnreadNotification();
        })
    },
  },
  async mounted() {
    await this.generateContents();
    window.eventBus.$on("loadUserData", val => {
      if (val === true) {
        this.generateContents();
      }
    });
    setInterval(()=>{
      this.getUserContributions();
    },50000);
    this.checkUserActiveTime();
    this.getUserContributions();
    // console.log(`site is on ${process.env.NODE_ENV} mode`)

      // load feeds on click of a button
      $('#tweetBtn').click(() => {
          $('html,body').animate({
              scrollTop: 0,
          }, 1200);
          window.eventBus.$emit('loadFeeds', true);
          setTimeout(function () {
              $('.tweet').hide()
          },1000);
          return false;
      });
      // show tweet button if new review is requested
      // window.eventBus.$on('newReview', val => {
      //     if (val === true) {
      //         $('.tweet').show()
      //     }
      // })

  },
};
</script>

<style>
.br {
  border: solid 1px #000;
}
.tweet {
    position: fixed;
    z-index: 25;
    top: 30px;
    width: 100%;
    padding: 10px;
    text-align: center;
    display: none;
}
#tweetBtn {
    padding: 10px 20px;
    color: #fff;
    background-color: #0BA4E0;
    border: none;
    border-radius: 30px;
    box-shadow: 0 5px 10px rgba(0,0,0,.2);
    outline: none;
}
    #app {
        background-color: #fff;
        height: 100vh;
        width: 100%;
        float: left;
        overflow: auto;
    }
</style>
